import { Service } from '@roc/client-portal-shared/services';

const url = {
  REFERRAL_FEE_LINK: `/api/v1/document/formDocument/getReferralFeeLink`,
  GET_BANK_INFO: `/api/v1/document/formDocument/getBankInformation`,
  VALIDATE_REFERRAL_FEE_LINK: `/api/v1/lender/public/validateReferralFeeLink`,
  GENERATE_DOCUMENT: `/api/v1/lender/public/generateReferralFeeDocument`,
  APPROVE_BANK_INFO: `/api/v1/loan/approveEntityBankInformation`,
};

export class ReferralFeeExternalService extends Service {
  getReferralFeeLink(loanId: string) {
    return this.get(`${url.REFERRAL_FEE_LINK}?loanId=${loanId}`);
  }

  /** Resolves with the loan id and broker bank info status the signed link grants access to. */
  validateReferralFeeLink(token: string) {
    return this.get(url.VALIDATE_REFERRAL_FEE_LINK, { token });
  }

  getBankInfo(entityId: string) {
    return this.get(`${url.GET_BANK_INFO}?entityId=${entityId}&entityType=BrokerEntity`);
  }

  generateReferralFeeDocument(request: any, token: string) {
    return this.post(`${url.GENERATE_DOCUMENT}?token=${encodeURIComponent(token)}`, request, {
      'Content-Type': 'application/json',
    });
  }

  approveBankInformation(entityId: string) {
    return this.get(`${url.APPROVE_BANK_INFO}?entityId=${entityId}&entityType=BrokerEntity`);
  }
}
